export function fromBezierToArray(bezier: `cubic-bezier(${number}, ${number}, ${number}, ${number})`) {
  return bezier.replace("cubic-bezier(", "").replace(")", "").split(",").map(parseFloat)
}
